import React from 'react';
import AISuggestionCard from './AISuggestionCard';
import { AIRecommendation, AIRecommendationActions } from './types';
import { debugWarn } from '../../utils/debug';

type StepCardProps = {
  title: string;
  content: React.ReactNode;
  stepKey?: string;
  index?: number;
  badgeLabel?: string;
  recommendation?: AIRecommendation;
  recommendationActions?: AIRecommendationActions;
  isActive?: boolean;
  onPrimaryAction?: (actionType: AIRecommendationActions['primaryType']) => void;
  onSecondaryAction?: (actionType: AIRecommendationActions['secondaryType']) => void;
  onRedirectAction?: () => void;
};

const StepCard: React.FC<StepCardProps> = ({
  title,
  content,
  stepKey,
  index,
  badgeLabel,
  recommendation,
  recommendationActions,
  isActive = false,
  onPrimaryAction,
  onSecondaryAction,
  onRedirectAction,
}) => {
  return (
    <div
      className={`relative overflow-hidden rounded-2xl border ${
        isActive
          ? 'border-slate-100 bg-white shadow-[0_16px_40px_-20px_rgba(15,23,42,0.35)]'
          : 'border-slate-100 bg-white/80 opacity-70 transition-opacity hover:opacity-100'
      }`}
    >
      <div className="relative p-6">
        <div className="mb-4 flex items-center gap-3">
          {isActive ? (
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-emerald-100 text-emerald-700 text-sm font-semibold">
              {index ?? 1}
            </span>
          ) : badgeLabel ? (
            <span className="rounded bg-slate-100 px-2 py-1 text-[11px] font-bold uppercase tracking-wide text-slate-500">
              {badgeLabel}
            </span>
          ) : null}
          {title ? <h3 className="text-base font-semibold text-slate-900">{title}</h3> : null}
        </div>
        <div className="text-sm text-slate-700">{content}</div>
      </div>
      {recommendation && (
        <div className="border-t border-slate-100 px-6 pb-5 pt-4">
          <div
            onClickCapture={
              process.env.NODE_ENV !== 'production'
                ? () => {
                    debugWarn('[ai-recs][ui] card click capture', { stepKey, ts: Date.now() });
                  }
                : undefined
            }
          >
            <AISuggestionCard
              stepKey={stepKey}
              recommendation={recommendation}
              actions={recommendationActions}
              onPrimary={onPrimaryAction}
              onSecondary={onSecondaryAction}
              onRedirect={onRedirectAction}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default StepCard;
